import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Login from "./pages/Login";
import Welcome from "./pages/Welcome";
import MyProfile from "./pages/MyProfile";
import NotFound from "./pages/NotFound";
import ResetPassword from "./pages/ResetPassword";

import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import Attendance from "./pages/Attendance";
import Leave from "./pages/Leave";
import Payroll from "./pages/Payroll";
import PayrollCreate from "./pages/PayrollCreate";
import Payslips from "./pages/Payslips";
import Overtime from "./pages/Overtime";
import Tax from "./pages/Tax";
import SocialSecurity from "./pages/SocialSecurity";
import FinanceTransactions from "./pages/FinanceTransactions";
import FinanceSummary from "./pages/FinanceSummary";
import EmployeeFinance from "./pages/EmployeeFinance";
import Assets from "./pages/Assets";
import Procurement from "./pages/Procurement";
import ProjectTimeline from "./pages/ProjectTimeline";
import Projects from "./pages/Projects";
import MaContracts from "./pages/MaContracts";
import DevContracts from "./pages/DevContracts";
import Documents from "./pages/Documents";
import CompanyDocuments from "./pages/CompanyDocuments";
import CompanyDrive from "./pages/CompanyDrive";
import SharedFile from "./pages/SharedFile";
import Partners from "./pages/Partners";
import Announcements from "./pages/Announcements";
import Settings from "./pages/Settings";
import AuditLogs from "./pages/AuditLogs";
import CmruWelcome from "./pages/cmru/Welcome";
import CmruClassLists from "./pages/cmru/ClassLists";
import FoodHome from "./pages/food/Home";
import FoodDecide from "./pages/food/Decide";
import FoodDiary from "./pages/food/Diary";
import FoodBudget from "./pages/food/Budget";
import FoodPantry from "./pages/food/Pantry";
import FoodNearby from "./pages/food/Nearby";
import FoodFoods from "./pages/food/Foods";
import FoodProfile from "./pages/food/Profile";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/welcome" element={<Welcome />} />
    <Route path="/my-profile" element={<MyProfile />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/employees" element={<Employees />} />
    <Route path="/attendance" element={<Attendance />} />
    <Route path="/leave" element={<Leave />} />
    <Route path="/payroll" element={<Payroll />} />
    <Route path="/payroll/create" element={<PayrollCreate />} />
    <Route path="/payslips" element={<Payslips />} />
    <Route path="/overtime" element={<Overtime />} />
    <Route path="/tax" element={<Tax />} />
    <Route path="/social-security" element={<SocialSecurity />} />
    <Route path="/finance-transactions" element={<FinanceTransactions />} />
    <Route path="/finance-summary" element={<FinanceSummary />} />
    <Route path="/employee-finance" element={<EmployeeFinance />} />
    <Route path="/assets" element={<Assets />} />
    <Route path="/procurement" element={<Procurement />} />
    <Route path="/documents" element={<Documents />} />
    <Route path="/company-documents" element={<CompanyDocuments />} />
    <Route path="/company-drive" element={<CompanyDrive />} />
    <Route path="/shared-file/:token" element={<SharedFile />} />
    <Route path="/partners" element={<Partners />} />
    <Route path="/projects" element={<Projects />} />
    <Route path="/project-timeline" element={<ProjectTimeline />} />
    <Route path="/ma-contracts" element={<MaContracts />} />
    <Route path="/dev-contracts" element={<DevContracts />} />
    <Route path="/announcements" element={<Announcements />} />
    <Route path="/settings" element={<Settings />} />
    <Route path="/audit-logs" element={<AuditLogs />} />
    {/* ระบบ CMRU: ทุกหน้าขึ้นต้นด้วย /cmru/ และครอบด้วย CmruShell (ตรวจสิทธิ์เข้าระบบ + navbar ของ CMRU) */}
    <Route path="/cmru" element={<Navigate replace to="/cmru/welcome" />} />
    <Route path="/cmru/welcome" element={<CmruWelcome />} />
    <Route path="/cmru/class-lists" element={<CmruClassLists />} />
    <Route path="/cmru/class-lists/:uid" element={<CmruClassLists />} />
    {/* ระบบ "กินอะไรดี": ทุกหน้าขึ้นต้นด้วย /food/ และครอบด้วย FoodShell (ตรวจสิทธิ์เข้าระบบ + navbar ของระบบนี้) */}
    <Route path="/food" element={<Navigate replace to="/food/home" />} />
    <Route path="/food/home" element={<FoodHome />} />
    <Route path="/food/decide" element={<FoodDecide />} />
    <Route path="/food/diary" element={<FoodDiary />} />
    <Route path="/food/budget" element={<FoodBudget />} />
    <Route path="/food/pantry" element={<FoodPantry />} />
    <Route path="/food/nearby" element={<FoodNearby />} />
    <Route path="/food/foods" element={<FoodFoods />} />
    <Route path="/food/profile" element={<FoodProfile />} />
    <Route path="/home" element={<Navigate replace to="/welcome" />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
